import status from '../../functions/Status/status.dictionaries'

export const purchasedStatuses = [
  status.deliveryStatus.purchasedByTraveler,
  status.deliveryStatus.purchasedByAdmin,
  status.deliveryStatus.purchasedByAgentAdmin
]

// Purchased by Admin (excludes traveler purchases)
export const purchasedByAdminStatuses = [
  status.deliveryStatus.purchasedByAdmin,
  status.deliveryStatus.purchasedByAgentAdmin
]

export const deliveredToTravelerAddressStatuses = [
  status.deliveryStatus.confirmedDeliveredToTravelerAddressByAdmin,
  status.deliveryStatus.confirmedDeliveredToTravelerAddressByAgentAdmin,
  status.deliveryStatus.confirmedReceivedByTraveler,
  status.deliveryStatus.readyForDropoffAtLocker
]

export const deliveredToShopperStatuses = [
  status.deliveryStatus.confirmedDeliveredToShopperByTraveler,
  status.deliveryStatus.confirmedDeliveredToShopperByShopper,
  status.deliveryStatus.confirmedDeliveredToShopperByAdmin,
  status.deliveryStatus.confirmedDeliveredToShopperByAgentAdmin,
  status.deliveryStatus.awaitingShopperPickupFromLocker,
  status.deliveryStatus.confirmedDeliveredToShopperViaLocker
]

export enum FilterStatus {
  readyForPurchase = 'ready_for_purchase',
  purchased = 'purchased',
  deliveredToTravelerAddress = 'delivered_to_traveler_address',
  deliveredToShopper = 'delivered_to_shopper'
}
